// Call this to register your module to main application
var moduleName = 'virtoCommerce.marketplaceModule';

if (AppDependencies !== undefined) {
    AppDependencies.push(moduleName);
}

angular.module(moduleName, ['virtoCommerce.catalogModule', 'virtoCommerce.customerModule'])
    .constant('virtoCommerce.marketplaceModule.sellerPublicationRequestStatuses', [
        'Published',
        'HasStagedChanges',
        'WaitForApproval',
        'RequiresChanges',
        'Rejected',
        'Approved'
    ])
    .config(['$stateProvider', 
        function ($stateProvider) {
            $stateProvider.state('workspace.operatoritems',
                {
                    url: '/operator-items',
                    templateUrl: '$(Platform)/Scripts/common/templates/home.tpl.html',
                    controller: ['platformWebApp.bladeNavigationService',
                        function(bladeNavigationService) {
                            var blade = {
                                id: 'operatorItemsList',
                                title: 'marketplace.blades.seller-publication-request-list.title',
                                subtitle: 'marketplace.blades.seller-publication-request-list.subtitle',
                                breadcrumbs: [],
                                controller: 'virtoCommerce.marketplaceModule.sellerPublicationRequestListController',
                                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/seller-publication-request-list.tpl.html',
                                isClosingDisabled: true
                            };
                            bladeNavigationService.showBlade(blade);
                        }
                    ]
                });
            $stateProvider.state('workspace.mastercatalog',
                {
                    url: '/master-catalog',
                    templateUrl: '$(Platform)/Scripts/common/templates/home.tpl.html',
                    controller: ['$scope', 'platformWebApp.bladeNavigationService',
                        function ($scope, bladeNavigationService) {
                            var blade = {
                                id: 'masterCatalog',
                                title: 'marketplace.blades.master-catalog.title',
                                subtitle: 'marketplace.blades.master-catalog.subtitle',
                                breadcrumbs: [],
                                controller: 'virtoCommerce.marketplaceModule.masterCatalogController',
                                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/master-catalog.tpl.html',
                                isClosingDisabled: true
                            };
                            bladeNavigationService.showBlade(blade);
                            // Workaround for module css isolation: everything inside this menu item will be treated as part of catalog module
                            $scope.moduleName = 'vc-catalog';
                        }
                    ]
                });
            $stateProvider.state('workspace.operatororders',
                {
                    url: '/operator-orders',
                    templateUrl: '$(Platform)/Scripts/common/templates/home.tpl.html',
                    controller: ['$scope', 'platformWebApp.bladeNavigationService',
                        function ($scope, bladeNavigationService) {
                            var blade = {
                                id: 'operatorOrders',
                                title: 'orders.blades.customerOrder-list.title',
                                controller: 'virtoCommerce.orderModule.customerOrderListController',
                                template: 'Modules/$(VirtoCommerce.Orders)/Scripts/blades/customerOrder-list.tpl.html',
                                searchCriteria: { hasParentOperation: false },
                                isExpandable: true,
                                isClosingDisabled: true
                            };
                            bladeNavigationService.showBlade(blade);
                            // Workaround for module css isolation: everything inside this menu item will be treated as part of order module
                            $scope.moduleName = "vc-order";
                        }
                    ]
                });
            $stateProvider.state('workspace.sellers',
                {
                    url: '/sellers',
                    templateUrl: '$(Platform)/Scripts/common/templates/home.tpl.html',
                    controller: ['platformWebApp.bladeNavigationService',
                        function (bladeNavigationService) {
                            var blade = {
                                id: 'sellers',
                                title: 'marketplace.blades.seller-list.title',
                                subtitle: 'marketplace.blades.seller-list.subtitle',
                                controller: 'virtoCommerce.marketplaceModule.sellerListController',
                                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/seller-list.tpl.html',
                                isClosingDisabled: true,
                                customizeToolbar: false
                            };
                            bladeNavigationService.showBlade(blade);
                        }
                    ]
                });
            $stateProvider.state('workspace.fees',
                {
                    url: '/fees',
                    templateUrl: '$(Platform)/Scripts/common/templates/home.tpl.html',
                    controller: ['platformWebApp.bladeNavigationService',
                        function (bladeNavigationService) {
                            var blade = {
                                id: 'fees',
                                title: 'marketplace.blades.fees.title',
                                subtitle: 'marketplace.blades.fees.subtitle',
                                controller: 'virtoCommerce.marketplaceModule.feesController',
                                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/fees.tpl.html',
                                isClosingDisabled: true
                            };
                            bladeNavigationService.showBlade(blade);
                        }
                    ]
                });

            $stateProvider.state('workspace.offers',
                {
                    url: '/offers',
                    templateUrl: '$(Platform)/Scripts/common/templates/home.tpl.html',
                    controller: ['platformWebApp.bladeNavigationService',
                        function (bladeNavigationService) {
                            var blade = {
                                id: 'offers',
                                title: 'marketplace.blades.offer-list.title',
                                subtitle: 'marketplace.blades.offer-list.subtitle-all-vendors',
                                controller: 'virtoCommerce.marketplaceModule.offerListController',
                                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/offer-list.tpl.html',
                                isClosingDisabled: true
                            };
                            bladeNavigationService.showBlade(blade);
                        }
                    ]
                });

            $stateProvider.state('workspace.synchronization',
                {
                    url: '/synchronization',
                    templateUrl: '$(Platform)/Scripts/common/templates/home.tpl.html',
                    controller: ['platformWebApp.bladeNavigationService',
                        function (bladeNavigationService) {
                            var blade = {
                                id: 'synchronization',
                                title: 'marketplace.blades.synchronization-list.title',
                                subtitle: 'marketplace.blades.synchronization-list.subtitle',
                                controller: 'virtoCommerce.marketplaceModule.synchronizationListController',
                                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/synchronization-list.tpl.html',
                                isClosingDisabled: true
                            };
                            bladeNavigationService.showBlade(blade);
                        }
                    ]
                });

            $stateProvider.state('workspace.statemachine',
                {
                    url: '/state-machine',
                    templateUrl: '$(Platform)/Scripts/common/templates/home.tpl.html',
                    controller: ['platformWebApp.bladeNavigationService',
                        function (bladeNavigationService) {
                            var blade = {
                                id: 'state-machine-list',
                                controller: 'virtoCommerce.marketplaceModule.stateMachineListController',
                                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/state-machine-list.tpl.html',
                                isClosingDisabled: true
                            };
                            bladeNavigationService.showBlade(blade);
                        }
                    ]
                });
        }
    ])
    .run(['$http', '$compile', 'platformWebApp.mainMenuService', 'platformWebApp.widgetService', '$state', 'platformWebApp.toolbarService', 'virtoCommerce.marketplaceModule.webApi', 'platformWebApp.dialogService', 'platformWebApp.authService', 'virtoCommerce.coreModule.common.dynamicExpressionService', 'platformWebApp.bladeNavigationService', 'platformWebApp.pushNotificationTemplateResolver', 'VirtoCommerce.CustomerReviews.entityTypesResolverService', 'platformWebApp.metaFormsService',
        function ($http, $compile, mainMenuService, widgetService, $state, toolbarService, webApi, dialogService, authService, dynamicExpressionService, bladeNavigationService, pushNotificationTemplateResolver, entityTypesResolverService, metaFormsService) {

            // Register Vendors' products in main menu
            var sellersProductsMainMenuItem = {
                path: 'browse/operator-items',
                icon: 'fa fa-cloud-upload',
                title: 'marketplace.main-menu.sellers-products',
                priority: 15,
                action: function () { $state.go('workspace.operatoritems'); },
                permission: 'operator:resources'
            };
            mainMenuService.addMenuItem(sellersProductsMainMenuItem);

            // Register Master catalog in main menu
            var masterCatalogMainMenuItem = {
                path: 'browse/master-catalog',
                icon: 'fa fa-folder',
                title: 'marketplace.main-menu.master-catalog',
                priority: 17.5,
                action: function () { $state.go('workspace.mastercatalog'); },
                permission: 'operator:resources'
            };
            mainMenuService.addMenuItem(masterCatalogMainMenuItem);

            // Register Operator Orders in main menu
            var menuItem = {
                path: 'browse/operator-orders',
                icon: 'fa fa-file-text',
                title: 'marketplace.main-menu.operator-orders',
                priority: 95,
                action: function () { $state.go('workspace.operatororders'); },
                permission: 'operator:resources'
            };
            mainMenuService.addMenuItem(menuItem);

            // Register Vendors in main menu
            var menuItem = {
                path: 'browse/sellers',
                icon: 'fas fa-store',
                title: 'marketplace.main-menu.sellers',
                priority: 185,
                action: function () { $state.go('workspace.sellers'); },
                permission: 'operator:resources'
            };
            mainMenuService.addMenuItem(menuItem);

            // Register fees in main menu
            var menuItem = {
                path: 'browse/fees',
                icon: 'fa fa-usd',
                title: 'marketplace.main-menu.fees',
                priority: 35,
                action: function () { $state.go('workspace.fees'); },
                permission: 'operator:resources'
            };
            mainMenuService.addMenuItem(menuItem);

            // Register offers in main menu
            var offerMenuItem = {
                path: 'browse/offers',
                icon: 'fa fa-usd',
                title: 'marketplace.main-menu.offers',
                priority: 36,
                action: function () { $state.go('workspace.offers'); },
                permission: 'operator:resources'
            };
            mainMenuService.addMenuItem(offerMenuItem);

            // Register synchronization in main menu
            var synchronizationMenuItem = {
                path: 'browse/synchronization',
                icon: 'fa fa-repeat',
                title: 'marketplace.main-menu.synchronization',
                priority: 37,
                action: function () { $state.go('workspace.synchronization'); },
                permission: 'operator:resources'
            };
            mainMenuService.addMenuItem(synchronizationMenuItem);

            var stateMachineMenuItem = {
                path: 'configuration/state-machine',
                icon: 'fa fa-pencil-square-o',
                title: 'marketplace.main-menu.state-machines',
                priority: 2,
                action: function () { $state.go('workspace.statemachine'); },
                permission: 'operator:statemachines'
            };
            mainMenuService.addMenuItem(stateMachineMenuItem);

            // Add toolbar buttons to product
            toolbarService.register({
                name: "marketplace.blades.seller-publication-request-list.menu.approve",
                icon: 'fa fa-cloud-upload',
                executeMethod: function (blade) {
                    blade.isLoading = true;
                    blade.approvalRequestSent = true;
                    webApi.changeStatus({ operatorId: authService.userLogin, operatorName: authService.userLogin, sellerProductId: blade.sellerProduct.id, newStatus: 'Approved' }, () =>

                    webApi.getSellerProduct({ productId: blade.sellerProduct.id }, (data) => {
                        blade.sellerProduct = data;
                        blade.isLoading = false;
                        blade.approvalRequestSent = false;
                        if (blade.parentBlade && blade.parentBlade.refresh) {
                            blade.parentBlade.refresh();
                        }
                    })
                    );

                },
                canExecuteMethod: (blade) => blade.sellerProduct && blade.sellerProduct.status.includes('WaitForApproval') && !blade.approvalRequestSent,
                index: 3
            }, 'virtoCommerce.catalogModule.itemDetailController');

            toolbarService.register({
                name: "marketplace.blades.seller-publication-request-list.menu.decline",
                icon: 'fa fa-unlink',
                executeMethod: function (blade) {
                    var dialog = {
                        comment: { text: '' },
                        callback: function (decline) {
                            if (decline) {
                                blade.isLoading = true;
                                blade.approvalRequestSent = true;
                                webApi.changeStatus({ operatorId: authService.userLogin, operatorName: authService.userLogin, sellerProductId: blade.sellerProduct.id, newStatus: 'Rejected', comment: dialog.comment.text }, () =>
                                    webApi.getSellerProduct({ productId: blade.sellerProduct.id }, (data) => {
                                        blade.sellerProduct = data;
                                        blade.isLoading = false;
                                        blade.approvalRequestSent = false;
                                        if (blade.parentBlade && blade.parentBlade.refresh) {
                                            blade.parentBlade.refresh();
                                        }
                                    }));
                            }
                        }
                    }
                    dialogService.showDialog(dialog, 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/dialogs/declinePublishing-dialog.tpl.html', 'platformWebApp.confirmDialogController');
                },
                canExecuteMethod: (blade) => blade.sellerProduct && blade.sellerProduct.status.includes('WaitForApproval') && !blade.approvalRequestSent,
                index: 4
            }, 'virtoCommerce.catalogModule.itemDetailController');

            // Vendor details: Addresses widget
            var sellerAddressesWidget = {
                controller: 'virtoCommerce.marketplaceModule.sellerAddressesWidgetController',
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/seller-addresses-widget.tpl.html'
            };
            widgetService.registerWidget(sellerAddressesWidget, 'sellerDetails');


            // Seller Product total delete
            toolbarService.register({
                name: "marketplace.blades.seller-publication-request-list.menu.total-delete",
                icon: 'fas fa-trash-alt',
                executeMethod: function (blade) {
                    var dialog = {
                        callback: function (remove) {
                            if (remove) {
                                blade.isLoading = true;
                                webApi.deleteSellerProducts({ ids: blade.sellerProduct.id }, () => {
                                    blade.isLoading = false;
                                    blade.parentBlade.refresh();
                                    bladeNavigationService.closeBlade(blade);
                                });
                            }
                        }
                    }
                    dialogService.showDialog(dialog, 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/dialogs/deleteProduct-dialog.tpl.html', 'platformWebApp.confirmDialogController');
                },
                canExecuteMethod: (blade) => blade.sellerProduct,
                index: 5
            }, 'virtoCommerce.catalogModule.itemDetailController');

            // Vendor details: Addresses widget
            var sellerAddressesWidget = {
                controller: 'virtoCommerce.marketplaceModule.sellerAddressesWidgetController',
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/seller-addresses-widget.tpl.html'
            };
            widgetService.registerWidget(sellerAddressesWidget, 'sellerDetails');


            // Vendor details: Users widget
            var sellerUsersWidget = {
                controller: 'virtoCommerce.marketplaceModule.sellerUsersWidgetController',
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/seller-users-widget.tpl.html'
            };
            widgetService.registerWidget(sellerUsersWidget, 'sellerDetails');

            // Vendor details: Orders widget
            var sellerOrdersWidget = {
                controller: 'virtoCommerce.marketplaceModule.sellerOrdersWidgetController',
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/seller-orders-widget.tpl.html'
            };
            widgetService.registerWidget(sellerOrdersWidget, 'sellerDetails');

            // Vendor details: Categories widget
            var sellerCategoriesWidget = {
                controller: 'virtoCommerce.marketplaceModule.sellerCategoriesWidgetController',
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/seller-categories-widget.tpl.html'
            };
            widgetService.registerWidget(sellerCategoriesWidget, 'sellerDetails');

            // Vendor details: Publication requests widget
            var sellerApprovalRequestsWidget = {
                controller: 'virtoCommerce.marketplaceModule.sellerPublicationRequestsWidgetController',
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/seller-publication-requests-widget.tpl.html'
            };
            widgetService.registerWidget(sellerApprovalRequestsWidget, 'sellerDetails');

            // Order details: Seller orders widget
            widgetService.registerWidget({
                controller: 'virtoCommerce.marketplaceModule.orderSellerOrdersOrdersWidgetController',
                isVisible: function (blade) {
                    return blade.id === "orderDetail";
                },
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/order-seller-orders-widget.tpl.html'
            }, 'customerOrderDetailWidgets');

            // Product details: Product offers widget
            var itemOffersWidget = {
                controller: 'virtoCommerce.marketplaceModule.itemOffersWidgetController',
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/item-offers-widget.tpl.html'
            };
            widgetService.registerWidget(itemOffersWidget, 'itemDetail');

            // Offer details: offer product properties widget
            var offerItemPropertiesWidget = {
                controller: 'virtoCommerce.marketplaceModule.offerItemPropertiesWidgetController',
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/offer-item-properties-widget.tpl.html'
            };
            widgetService.registerWidget(offerItemPropertiesWidget, 'offerDetailsWidgetContainer');

            // Order details: order commission widget
            var orderFeeWidget = {
                controller: 'virtoCommerce.marketplaceModule.orderFeeWidgetController',
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/order-fee-widget.tpl.html'
            };
            widgetService.registerWidget(orderFeeWidget, 'customerOrderDetailWidgets');

            // Seller details: seller rating widget
            var sellerRatingWidget = {
                controller: 'virtoCommerce.marketplaceModule.sellerRatingWidgetController',
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/seller-rating-widget.tpl.html'
            };
            widgetService.registerWidget(sellerRatingWidget, 'sellerDetails');

            // Seller details: seller fulfillments widget
            var sellerFulfillmentWidget = {
                controller: 'virtoCommerce.marketplaceModule.sellerFulfillmentWidgetController',
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/seller-fulfillment-widget.tpl.html'
            };
            widgetService.registerWidget(sellerFulfillmentWidget, 'sellerDetails');

            // Seller details: seller import history widget
            var sellerImportHistoryWidget = {
                isVisible: function () { return true; },
                controller: 'virtoCommerce.marketplaceModule.sellerImportHistoryWidgetController',
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/seller-import-history-widget.tpl.html'
            };
            widgetService.registerWidget(sellerImportHistoryWidget, 'sellerDetails');

            // Seller details: seller import profiles widget
            var sellerImportProfilesWidget = {
                controller: 'virtoCommerce.marketplaceModule.sellerImportProfilesWidgetController',
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/seller-import-profiles-widget.tpl.html'
            };
            widgetService.registerWidget(sellerImportProfilesWidget, 'sellerDetails');

            var sellerImportProfileSettingsWidget = {
                controller: 'platformWebApp.entitySettingsWidgetController',
                template: '$(Platform)/Scripts/app/settings/widgets/entitySettingsWidget.tpl.html'
            };
            widgetService.registerWidget(sellerImportProfileSettingsWidget, 'sellerImportProfileDetails');

            var stateMachineOrderWidget = {
                controller: 'virtoCommerce.marketplaceModule.stateMachineOrderWidgetController',
                template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/widgets/state-machine-order-widget.tpl.html'
            };
            widgetService.registerWidget(stateMachineOrderWidget, 'customerOrderDetailWidgets');

            var availableExcludings = [
                {
                    id: 'ConditionCategoryIsNot'
                },
                {
                    id: 'ConditionProductIsNot'
                }
            ];

            dynamicExpressionService.registerExpression({
                id: 'VendorCommissionCondition',
                displayName: 'Vendor ...',
                templateURL: 'VendorCommissionCondition.html',
                newChildLabel: 'Add condition'
            });

            dynamicExpressionService.registerExpression({
                id: 'BlockCommissionCondition',
                displayName: 'Commission ...',
                templateURL: 'BlockCommissionCondition.html',
                newChildLabel: 'Add condition'
            });

            dynamicExpressionService.registerExpression({
                id: 'VcmpConditionCategoryIs',
                displayName: 'Category is ...',
                templateURL: 'ConditionCategoryIs.html',
                availableChildren: availableExcludings,
                newChildLabel: 'Excluding'
            });

            dynamicExpressionService.registerExpression({
                id: 'ConditionCategoryIsNot',
                displayName: 'Excluding category ...',
                templateURL: 'ConditionCategoryIsNot.html'
            });

            dynamicExpressionService.registerExpression({
                id: 'VcmpConditionProductIs',
                displayName: 'Product is ...',
                templateURL: 'ConditionProductIs.html'
            });

            dynamicExpressionService.registerExpression({
                id: 'ConditionProductIsNot',
                displayName: 'Excuding product ...',
                templateURL: 'ConditionProductIsNot.html'
            });

            dynamicExpressionService.registerExpression({
                id: 'VcmpConditionVendorIs',
                displayName: 'Vendor is ...',
                templateURL: 'ConditionVendorIs.html'
            });

            $http.get('Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/dynamicConditions/templates.html').then(function (response) {
                $compile(response.data);
            });

            // register notification template
            pushNotificationTemplateResolver.register({
                priority: 900,
                satisfy: function (notify, place) { return place === 'history' && notify.notifyType === 'SyncPushNotification'; },
                template: 'Modules/$(VirtoCommerce.Search)/Scripts/notifications/historyIndex.tpl.html',
                action: function (notify) {
                    var blade = {
                        id: 'syncProgress',
                        notification: notify,
                        controller: 'virtoCommerce.marketplaceModule.synchronizationDetailsController',
                        template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/synchronization-details.tpl.html'
                    };
                    bladeNavigationService.showBlade(blade);
                }
            });

            pushNotificationTemplateResolver.register({
                priority: 900,
                satisfy: function (notify, place) { return place === 'header-notification' && notify.notifyType === 'SyncPushNotification'; },
                template: 'Modules/$(VirtoCommerce.Search)/Scripts/notifications/headerNotification.tpl.html',
                action: function (notify) { $state.go('workspace.pushNotificationsHistory', notify) }
            });

            //Seller entityType resolver
            entityTypesResolverService.registerType({
                entityType: 'Seller',
                icon: 'fas fa-store',
                entityIdFieldName: 'sellerId',
                detailBlade: {
                    id: 'sellerDetails',
                    title: 'marketplace.blades.seller-details.title',
                    subtitle: 'marketplace.blades.seller-details.subtitle',
                    controller: 'virtoCommerce.marketplaceModule.sellerDetailsController',
                    template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/seller-details.tpl.html'
                },
                getEntity: function (entityId, setEntityCallback) {
                    webApi.getSellerById({ id: entityId }, (data) => {
                        setEntityCallback(data.name, data.logo);
                    });
                },
                knownChildrenTypes: []
            });

            metaFormsService.registerMetaFields('Seller',
                [
                    {
                        name: 'name',
                        title: 'marketplace.blades.seller-details.labels.name',
                        valueType: 'ShortText'
                    },
                    {
                        name: 'isActive',
                        title: 'marketplace.blades.seller-details.labels.is-active',
                        valueType: 'Boolean'
                    },
                    {
                        name: 'commissionFee',
                        templateUrl: 'sellerDetails-feeSelector.html'
                    },
                    {
                        name: 'groups',
                        title: 'marketplace.blades.seller-details.labels.groups',
                        templateUrl: 'sellerDetails-groupsSelector.html'
                    },
                    {
                        name: 'registrationId',
                        title: 'marketplace.blades.seller-details.labels.registration-id',
                        valueType: 'ShortText'
                    },
                    {
                        name: 'outerId',
                        title: 'marketplace.blades.seller-details.labels.outer-id',
                        valueType: 'ShortText'
                    },
                    {
                        name: 'logo',
                        title: 'marketplace.blades.seller-details.labels.logo',
                        templateUrl: 'sellerDetails-logoImage.html'
                    },
                    {
                        name: 'approvalPolicy',
                        title: 'marketplace.blades.seller-details.labels.approval-policy',
                        templateUrl: 'sellerDetails-approvalSelector.html'
                    },
                    {
                        name: 'description',
                        title: 'marketplace.blades.seller-details.labels.description',
                        valueType: 'LongText'
                    },
                    {
                        name: 'deliveryTime',
                        title: 'marketplace.blades.seller-details.labels.delivery-time',
                        valueType: 'LongText'
                    },
                ]
            );
        }
    ]);
